var _defs, _circle, _line, _line2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack168({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.44,
    cy: 10.18,
    r: 4.32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.61,
    y1: 1.5,
    x2: 3.61,
    y2: 13.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.27,
    y1: 1.5,
    x2: 7.27,
    y2: 13.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.35,5.71a2.91,2.91,0,0,1-1,.19,1.75,1.75,0,0,1-1.26-.44A1.77,1.77,0,0,1,8.58,4.2a1.69,1.69,0,0,1,1.83-1.74,2.12,2.12,0,0,1,.84.15L11.14,3a1.71,1.71,0,0,0-.74-.15A1.27,1.27,0,0,0,9,4.18a1.24,1.24,0,0,0,1.3,1.36,1.4,1.4,0,0,0,.58-.09v-1h-.68V4.09h1.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12,2.49h1.82v.37H12.44V4h1.28v.36H12.44V5.87H12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.88,2.49V5.87h-.43V2.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack168);
export default __webpack_public_path__ + "static/media/Symbolpack_1_68.cc62b1e844a546720535e022a36b7578.svg";
export { ForwardRef as ReactComponent };